import { useEffect, useState } from "react";
import { loadSiteConfig } from "@/lib/siteConfig";

const KEY = "lumiere_cookie_consent";
export const CONSENT_CHANGE_EVENT = "lumiere:consent-change";
export const OPEN_PREFS_EVENT = "lumiere:open-cookie-prefs";

// Assume the banner is enabled until /site-config resolves — the conservative
// default (ask first) rather than tracking freely while we don't know yet.
let bannerEnabled = true;

// La configuration vient de lib/siteConfig.js, et non d'un second chargeur
// propre à ce module. Les deux existaient en parallèle, chacun avec son cache,
// ce qui appelait /site-config DEUX FOIS à chaque chargement de page pour
// exactement la même réponse.
function bannerFromConfig() {
  return loadSiteConfig().then((config) => {
    bannerEnabled = config?.cookie_consent_enabled !== false;
    return bannerEnabled;
  });
}

export function useCookieBannerEnabled() {
  const [enabled, setEnabled] = useState(bannerEnabled);
  useEffect(() => {
    let active = true;
    bannerFromConfig().then((v) => active && setEnabled(v));
    return () => {
      active = false;
    };
  }, []);
  return enabled;
}

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setConsent(analytics) {
  const value = { analytics, decided_at: new Date().toISOString() };
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
    if (!analytics) {
      // Withdraw any persistent identifier right away — visits from now on
      // are tracked anonymously, session by session, with nothing kept
      // between visits.
      localStorage.removeItem("lumiere_sid");
      document.cookie = "lumiere_ad=; max-age=0; path=/";
    }
  } catch {
    /* ignore (private browsing / storage full) */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, { detail: value }));
  return value;
}

export function hasAnalyticsConsent() {
  return getConsent()?.analytics === true;
}

// Whether a durable, cross-visit identifier (localStorage session id, ad
// attribution cookie) may be stored. When the banner feature itself is
// switched off site-wide, tracking behaves as it always did (fully
// persistent). Otherwise it follows the visitor's choice — refused or not
// yet decided means "track this visit, but don't remember who they are".
export function shouldPersistTracking() {
  if (!bannerEnabled) return true;
  return hasAnalyticsConsent();
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(OPEN_PREFS_EVENT));
}
